module.exports = __webpack_public_path__ + "media/svg-new/008-left-arrow-f7b94606.svg";